export default interface McmSegmentRule {
  field: string;
  operator: string;
  value: string | number | boolean;
}

// UI-only form state (multi-value tag inputs)
export interface SegmentBuilderRule {
  localId: string;
  field: string;
  operator: string;
  values: string[];
  valueType: "select" | "text" | "date";
}

export function createEmptyBuilderRule(): SegmentBuilderRule {
  return {
    localId: `rule-${Date.now()}-${Math.random()}`,
    field: "",
    operator: "",
    values: [],
    valueType: "select",
  };
}
